'use client';

import Link from 'next/link';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { useChromePathname } from '@/shared/components/providers/chrome-pathname';
import type { NavigationItem } from '@/components/layout/constants/navigation-constants';
import { useWhatsNewRailTargets } from '@/components/layout/whats-new/use-whats-new-rail-targets';
import { tourAnchor } from '@/shared/lib/tours/anchors';
import { NewBadge } from './new-badge';

interface NavMainProps {
  items: NavigationItem[];
}

export function NavMain({ items }: NavMainProps) {
  // Null at prerender/first render → no active state; the pre-paint fix-up
  // script stamps data-active from data-active-match before first paint.
  const pathname = useChromePathname();
  const newTargets = useWhatsNewRailTargets(items.map((item) => item.href));

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => {
            const isActive =
              pathname !== null && (pathname === item.href || pathname.startsWith(item.href + '/'));
            return (
              <SidebarMenuItem key={item.name}>
                <SidebarMenuButton asChild isActive={isActive} tooltip={item.name}>
                  <Link
                    href={item.href}
                    data-active-match="prefix"
                    suppressHydrationWarning
                    className="relative"
                    {...(item.tourAnchor ? tourAnchor(item.tourAnchor) : {})}
                  >
                    <item.icon />
                    <span>{item.name}</span>
                    {newTargets.has(item.href) && <NewBadge />}
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
